import { AlreadyApplied, CoBrandingLogoReceipt } from '@insify/funnel-components';

import { useCoBranding } from '../../hooks/useCoBranding';
import { useContent } from '../../hooks/useContent';

export function AlreadyAppliedPage(): JSX.Element {
  const { alreadyApplied } = useContent() || {};
  const { hasCoBrandingLoaded, branding } = useCoBranding();

  return (
    <AlreadyApplied
      logo={
        hasCoBrandingLoaded
          ? ({ className }) => <CoBrandingLogoReceipt branding={branding} className={className} />
          : undefined
      }
      content={alreadyApplied}
    />
  );
}
